import apiClient from '../middleware/apiClient';
import { LATE_FEE_CREDIT, LATE_FEE_CREDIT_ENROLL } from '../helpers/apis';
import { COTTON_LATE_FEE_CREDIT, COTTON_LATE_FEE_CREDIT_ENROLL } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';
import { dispatchSendTransaction } from './adobe';

// Fetch Payment
export const GET_LATE_FEE_CREDIT = 'GET_LATE_FEE_CREDIT';
export const GET_LATE_FEE_CREDIT_SUCCESS = 'GET_LATE_FEE_CREDIT_SUCCESS';
export const GET_LATE_FEE_CREDIT_FAILURE = 'GET_LATE_FEE_CREDIT_FAILURE';

function dispatchGetLateFeeCredit(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_LATE_FEE_CREDIT : LATE_FEE_CREDIT;
  return {
    type: GET_LATE_FEE_CREDIT,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetLateFeeCreditSuccess(latefeecredit) {
  return {
    type: GET_LATE_FEE_CREDIT_SUCCESS,
    payload: latefeecredit,
  };
}

function dispatchGetLateFeeCreditFailure(error) {
  return {
    type: GET_LATE_FEE_CREDIT_FAILURE,
    payload: error,
  };
}

export const getLateFeeCredit = (options = {}) => async (dispatch, getState) => {
  const { latefeecredit: { cached } = {} } = getState();
  if (cached && !options.force) {
    return null;
  }

  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchGetLateFeeCredit(isCottonSession)).payload;
    return dispatch(dispatchGetLateFeeCreditSuccess(response));
  } catch (error) {
    dispatch(dispatchGetLateFeeCreditFailure(error));
    throw error;
  }
};

export const ENROLL_LATE_FEE_CREDIT = 'ENROLL_LATE_FEE_CREDIT';
export const ENROLL_LATE_FEE_CREDIT_SUCCESS = 'ENROLL_LATE_FEE_CREDIT_SUCCESS';
export const ENROLL_LATE_FEE_CREDIT_FAILURE = 'ENROLL_LATE_FEE_CREDIT_FAILURE';

function dispatchEnrollLateFeeCredit(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_LATE_FEE_CREDIT_ENROLL : LATE_FEE_CREDIT_ENROLL;
  return {
    type: ENROLL_LATE_FEE_CREDIT,
    payload: apiClient.fetch(endpoint, { method: 'POST' }),
  };
}

function dispatchEnrollLateFeeCreditSuccess(latefeecredit) {
  return {
    type: ENROLL_LATE_FEE_CREDIT_SUCCESS,
    payload: latefeecredit,
  };
}

function dispatchEnrollLateFeeCreditFailure(error) {
  return {
    type: ENROLL_LATE_FEE_CREDIT_FAILURE,
    payload: error,
  };
}

export const enrollLateFeeCredit = () => async (dispatch) => {
  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchEnrollLateFeeCredit(isCottonSession)).payload;
    dispatch(dispatchSendTransaction({
      name: 'self service transaction',
      action: 'self service transaction',
      transaction: 'billing:latefee:enroll',
    }));
    return dispatch(dispatchEnrollLateFeeCreditSuccess(response));
  } catch (error) {
    dispatch(dispatchEnrollLateFeeCreditFailure(error));
    throw error;
  }
};
